import {Component, EventEmitter, inject, input, Input, OnInit, Output} from '@angular/core';
import {WorkDialogComponent} from "../../work/work-dialog/work-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {RoleService} from "../../role/role.service";
import {catchError, first} from "rxjs/operators";
import {AdminService} from '../../admin/services/admin.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsyncPipe, DatePipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatChipRow, MatChipsModule } from '@angular/material/chips';
import { AssignUserComponent } from '../../work/assign-user/assign-user.component';
import { WorkService } from '../../work/work.service';
import { EMPTY } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-document-works',
    templateUrl: './document-works.component.html',
    styleUrls: ['./document-works.component.scss'],
    imports: [
      AsyncPipe,
      DatePipe,
      MatChipsModule,
      MatIconModule,
      MatStepperModule,
      MatTooltipModule,
      NgClass,
    ]
})
export class DocumentWorksComponent implements OnInit {
  @Input() order:any = {works: []};
  
  @Input() works = [];
  
  @Input() modalComponent = false;
  
  @Output() load = new EventEmitter();
  
  requirementFirstLetter: string;


  private readonly snackBar = inject(MatSnackBar);

  private readonly workService = inject(WorkService);


  constructor(
    private matDialog: MatDialog,
    private roleService: RoleService,
    public adminService: AdminService
  ) {
    }

  ngOnInit() {
    const text = this.adminService.getText('requirement');
    this.requirementFirstLetter = text && text.length > 0 ? text.charAt(0).toUpperCase() : '';
  }
  openWork(work){
    this.roleService.can('read','work').pipe(first()).forEach((value)=>{
      if(value){
        this.matDialog.open(WorkDialogComponent,{data:
            {id: work.id, type: work.type}, minWidth: '80%'
        }).afterClosed().toPromise().then(()=>this.load.emit(true));
      }
    });
  }

  canUpdateWork() {
    return this.roleService.can('update', 'work');
  }

  setUser(event, values) {
    event.preventDefault();
    event.stopPropagation();

    if (!values.roles_id) {
      return;
    }
   
    this.matDialog.open(AssignUserComponent, { data: values.roles_id }).afterClosed().subscribe((user) => {
      if (!user) {
        return;
      }

      this.workService.update(values.id, { user_id: user.id }).pipe(
        catchError(() => {
          this.snackBar.open(
            'No se pudo asignar el usuario al trabajo',
            'Cerrar',
            { duration: 3000, panelClass: 'snackbar-error' }
          );
          return EMPTY;
        }),
      ).subscribe((s) => {
        this.load.emit(true);
        this.snackBar.open(
          'Usuario asignado al trabajo correctamente',
          'Cerrar',
          { duration: 3000, panelClass: 'snackbar-success' }
        );
      })
    });
  }


}
